export default __webpack_public_path__ + "static/planeInCloudsSmall-5f60049e5f8170aa848cdef37d0395e3.png";